<template>
	<div>
		<div class="oa_input flex" style="width: 100%;position: relative;flex-direction: row;align-items: center;">
			<template v-if="islist">
				<el-autocomplete :ref="ref" v-model="inputvalue" v-bind="$props" @change="change"
					:fetch-suggestions="querySearch" @select="handleSelect">
					<el-button v-if="importsearch" slot="append" icon="el-icon-upload2" size="mini" @click="buttonClick">
					</el-button>
				</el-autocomplete>
				<vxe-modal v-model="modalShow" :lock-view="false" :mask="false" show-footer height="600" width="600"
					destroy-on-close :loading="loading">
					<template #title>
						<span>批量查询</span>
					</template>
					<template #default>
						<vxe-grid :ref="tableRef" @toolbar-button-click="toolbarButtonClick" v-bind="GridOptions">
							<template #operate="{ row }">
								<vxe-button status="danger" type="text" icon="vxe-icon-delete" @click="importdelete(row)">删除
								</vxe-button>
							</template>
						</vxe-grid>
					</template>
					<template #footer>
						<template v-if="mode=='box'">
							<vxe-button status="primary" @click="submit(true)">查询</vxe-button>
							<vxe-button @click="modalShow = false">返回</vxe-button>
						</template>
						<template v-else>
							<vxe-button status="primary" @click="submit(true)">查询</vxe-button>
							<vxe-button @click="modalShow = false">返回</vxe-button>
						</template>
					</template>
				</vxe-modal>
			</template>
			<template v-else>
				<template v-if="!renderCell">		
					<el-input :class="{penetrate:penetrate}" @click.native="penetrate?preview:''" :type="inputprops.type" :rows="inputprops.rows" :ref="ref" v-model="inputvalue" v-bind="$props" @blur="blur" @change="change" @input="change"></el-input>
				</template>
				<template v-else>
					<span>{{value}}</span>
				</template>
			</template>		
		</div>
		<component ref="componentRef" :is="penetrateComponentConfig.component" v-bind="penetrateComponentConfig.props"
				v-if="penetrateComponentConfig" />
	</div>


</template>
<style scoped>
	.inputbutton {
		border-radius: 0px;
		box-sizing: border-box;
		border-left: 0px;
		position: relative;
		padding: 7px 8px;
	}
	.oa_input>div{
		width:100%
	}
</style>
<script>
	import penetrate from '@_system/components/base/mixins/penetrate/penetrate.js'
	import selectBase from '@_system/components/base/select.js'
	export default {
		mixins: [selectBase,penetrate],
		props: {
			inputprops: {
				default: () => {
					return {
						type:'text',
						rows:2
					}
				}
			},
			table: {
				default: () => {
					return null
				}
			},
			importsearch: {
				default: () => {
					return false
				}
			},
			querySearchfield: {
				default: () => {
					return [{
						"value": "不为空"
					},{
						"value": "为空"
					}]
				}
			},
		},
		data() {
			return {
				inputvalue: this.value,
				loading: false,
				modalShow: false,
				GridOptions: {},
				tableRef: Math.random(),
				importColumns: [],
				importData: [],
				tableImportcolumns: [],
				mode: 'list',
				ref: Math.random(),
			}
		},
		created() {


		},
		mounted() {
			this.inputvalue = this.value
			// if (this.$slots.append) {
			// 	this.$refs.input.setAttribute('readonly', true)
			// }


			// 	let i = document.createElement('i')
			// 	this.$refs.input.parentNode.appendChild(<i class="el-icon-delete"></i>)
		},
		watch: {
			value(v) {
				//console.log(v,1111)
				this.inputvalue = v
				// this.change(v)
			},
			renderCell(e) {
				if (!e) {
					this.$nextTick(() => {
						this.$refs[this.ref].focus()
					})
				}
			}
			// disabled(val) {
			// 	if (this.$slots.append && val) {
			// 		this.hiddenAppend()
			// 	}
			// },
			// readonly(val) {
			// 	if (this.$slots.append && val) {
			// 		this.hiddenAppend()
			// 	}
			// }
		},
		computed: {

		},
		methods: {
			querySearch(queryString, cb) {
				cb(this.querySearchfield)
			},
			handleSelect(e) {
				this.change(e.value)
			},
			buttonClick() {
				this.importColumns = []
				this.tableImportcolumns = []
				let params = this.tableFormInfo.$form.$parent.params
				// console.log(this.tableFormInfo,'tableFormInfo')
				if (params && params.mode == 'box') {
					this.mode = 'box'
					let tablecolumn = []
					// console.log(params.store.table.getTableColumn().visibleColumn,'table')
					if(params.store.table){
						tablecolumn = params.store.table.getTableColumn().visibleColumn
					}else{
						tablecolumn = this.tableFormInfo.$form.$parent.getTableColumn().visibleColumn
					}
					
					tablecolumn.forEach((item) => {
						let editRender = item.editRender
						if (editRender && !editRender.props.readonly && !editRender.props.disabled && editRender
							.name != '$quote') {
							this.tableImportcolumns.push({
								field: item.field,
								title: item.title
							})
						}
					})
				}


				this.importColumns.push({
					field: this.tableFormInfo.item.title,
					title: this.tableFormInfo.item.title,
					minWidth: 100,
					titlePrefix: {
						icon: 'vxe-icon-edit'
					},
					editRender: {
						name: 'ElInput'
					},
					cellRender: {
						name: 'ElInput'
					}
				})

				this.tableImportcolumns.forEach((item) => {
					this.importColumns.push({
						field: item.title,
						title: item.title,
						minWidth: 100,
						titlePrefix: {
							icon: 'vxe-icon-edit'
						},
						editRender: {
							name: 'ElInput'
						},
						cellRender: {
							name: 'ElInput'
						}
					})
				})

				this.importColumns.push({
					title: '操作',
					fixed: 'right',
					width: 80,
					slots: {
						default: 'operate'
					}
				})

				let GridOptions = {
					border: true,
					height: '480',
					resizable: true,
					keepSource: true,
					showOverflow: true,
					align: 'left',
					toolbarConfig: {
						buttons: [{
							name: '导入',
							code: 'import',
							status: 'success',
						}, {
							name: '下载模板',
							code: 'importtemplate',
							status: '',
						}, {
							name: '新增',
							code: 'add',
							status: 'primary',
						}]
					},
					importConfig: {
						types: ['xls', 'xlsx'],
						remote: true,
						importMethod: this.importMethod,
					},
					editConfig: {
						trigger: 'click',
						mode: 'cell',
						showStatus: true,
						showIcon: false
					},
					columns: this.importColumns,
					data: this.importData
				}
				this.GridOptions = GridOptions


				console.log(GridOptions,'GridOptions')

				this.modalShow = true

				// console.log(this.tableFormInfo.$form.$parent.commitProxy('query', {
				// 	code: 123
				// }))
			},
			importMethod(e) {

				this.importColumns = []
				this.importData = []

				let file = e.file
				let reader = new FileReader();
				reader.onload = (e) => {
					let data = e.target.result
					let workbook = this.$XLSX.read(data, {
						type: 'binary'
					})
					let sheetName = workbook.SheetNames[0];
					let worksheet = workbook.Sheets[sheetName]
					let jsonData = this.$XLSX.utils.sheet_to_json(worksheet)
					if (jsonData.length != 0) {
						this.$refs[this.tableRef].reloadData([]).then(() => {
							jsonData.forEach((item) => {
								this.$refs[this.tableRef].insertAt(item, -1)
							})
						})
					} else {
						this.$message.error('暂无数据')
					}
				}
				reader.readAsBinaryString(file)


			},
			importdelete(e) {
				this.$refs[this.tableRef].remove(e)
			},
			toolbarButtonClick(e) {
				if (e.code == 'add') {
					this.$refs[this.tableRef].insertAt({}, -1)
				}
				if (e.code == 'importtemplate') {
					this.$refs[this.tableRef].loadData(e.data).then(() => {
						this.$refs[this.tableRef].exportData({
							filename: '批量查询',
							type: 'xlsx',
							data: [],
						})
					})
				}
			},
			submit(withimport) {
				this.loading = true
				// let matchData = []
				let search = []
				let data = this.$refs[this.tableRef].getTableData().fullData
				if (data.length != 0) {
					data.forEach((item) => {
						for (let i in item) {
							if (i == this.tableFormInfo.item.title) {
								if(item[i]){
									item[i] = item[i].toString()
									search.push(item[i].replace(/[\s\n]+/g, ''))
								}
							}
						}
					})
					let param = {
						currentPage: -1
					}
					param[this.tableFormInfo.item.field] = search.join(',')			
					this.tableFormInfo.$form.$parent.commitProxy('query', param).then(() => {
						if (withimport) {
							let newlist = []
							let list = this.tableFormInfo.$form.$parent.getTableData().fullData
							data.forEach((item) => {
								let searchdata = list.find((obj) => {
									return item[this.tableFormInfo.item.title] == obj[this
										.tableFormInfo.item.field]
								})
								if (searchdata) {
									searchdata = JSON.parse(JSON.stringify(searchdata))
									let reversearchdata = {}
									for (let i in item) {
										this.tableImportcolumns.forEach((tlc) => {
											if (i == tlc.title) {
												reversearchdata[tlc.field] = item[i]
											}
										})
									}
									for (let j in reversearchdata) {
										searchdata['import_' + j] = reversearchdata[j]
									}
								}
								if(searchdata){
									delete searchdata._X_ROW_KEY
									delete searchdata._X_ROW_CHILD
									newlist.push(searchdata)
								}			
							})
					
							
							// newlist = newlist.map((item) => {
							// 	delete item._X_ROW_KEY
							// 	delete item._X_ROW_CHILD
							// })


							// list.forEach((item) => {
							// 	let searchdata = data.find((obj) => {
							// 		return obj[this.tableFormInfo.item.title] == item[this
							// 			.tableFormInfo.item.field]
							// 	})
							// 	if (searchdata) {
							// 		let reversearchdata = {}
							// 		for (let i in searchdata) {
							// 			this.tableImportcolumns.forEach((tlc) => {
							// 				if (i == tlc.title) {
							// 					reversearchdata[tlc.field] = searchdata[i]
							// 				}
							// 			})
							// 		}
							// 		for (let j in reversearchdata) {
							// 			item['import_' + j] = reversearchdata[j]
							// 		}
							// 	}
							// })
							let pager = this.tableFormInfo.$form.$parent.getProxyInfo().pager
							pager.currentPage = 1
							// pager.pageSize = newlist.length
							pager.total = newlist.length
							// console.log(newlist)
							this.tableFormInfo.$form.$parent.reloadData(newlist)
							// console.log(newlist)
							this.loading = false
						}
						this.modalShow = false
					},()=>{
						this.loading = false
					})

				} else {
					this.$message.error('暂无数据')
				}
			},

			// hiddenAppend() {
			// 	this.$slots.append.forEach((item) => {
			// 		item.elm.parentNode.parentNode.removeChild(item.elm.parentNode)
			// 	})
			// }
		}
	}
</script>
